import React, { useState } from 'react';
import Typography from '../components/v2/Typography';
import Button from '../components/v2/Button';
import { Download, ArrowRight, Search, Menu, SearchIcon, Globe, InfoIcon, CheckIcon } from 'lucide-react';
import DomainCard from '../components/v2/DomainCard';
import IButton from '../components/v2/IButton';
import Input from '../components/v2/Input';
import Textarea from '../components/v2/TextArea';
import { Link } from 'react-router-dom';


export const faqData = [
    { q: "What is WHOIS domain lookup?", a: "Short, simple answer…" },
    { q: "What does the WHOIS database contain?", a: "Another answer…" },
  ];
  
  
  function Faq({ data = [], noBorder = false, leftAligned = false, showHeader = false, useNumber = false }) {
    return (
      <section className={`faq-wrapper ${noBorder ? "no-border" : ""} ${leftAligned ? "left-aligned" : ""}`}>
        <div className="inner">
          {showHeader && <div className="faq-hdr">
            <Typography variant="h1">Frequently Asked Questions</Typography>
          </div>}
          <ul className="faq-component">
            {data.map(({ q, a }, i) => (
              <FaqRow key={i} useNumber={useNumber} question={q} answer={a} i={i} />
            ))}
          </ul>
        </div>
      </section>
    );
  }
  
  function FaqRow({ question, answer, useNumber, i }) {
    const [open, setOpen] = useState(false);
    return (
      <li className={`faq-row ${open ? "open" : ""}`}>
        <button
          className="faq-row-question"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
        >
          <span className="faq-row-icon" style={useNumber ? {lineHeight: "28px"} : {}}>{useNumber ? i + 1 : open ? "−" : "+"}</span>
          <span className="faq-row-text">{question}</span>
        </button>
        <div className="faq-row-answer">{answer}</div>
      </li>
    );
  }
  

  export default Faq;